import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactNode;
};

export const StyledHeader: React.FC<Props> = ({ children }) => {
  return <Wrapper data-testid="heading">{children}</Wrapper>;
};

const Wrapper = styled.div`
  font-size: 24px;
  margin: 48px 0 24px;
  font-weight: 700;
  line-height: 30.86px;
`;
